module.exports = __webpack_public_path__ + "static/media/MarkJarchow.ef69cfb9.png";